
<div class="page">

    <div class="page-header">
        <div class="breadcrumb">
            <p-breadcrumb [model]="breadcrumbs" [home]="homeBreadcrumb"></p-breadcrumb>
        </div>
        <div class="search">
            <input pInputText type="text" (input)="filter(dt, $event)" placeholder="Search..." />           
        </div>
        <div class="actions">
            <button pButton pRipple label="New" icon="pi pi-plus" class="button-action p-button-success p-mr-2" (click)="openNew()"></button>
            <button pButton pRipple label="Delete" icon="pi pi-trash" class="button-action p-button-danger" (click)="deleteSelectedTunaPieceProcesses()" [disabled]="!selectedTunaPieceProcesses || !selectedTunaPieceProcesses.length "></button>
        </div> 
    </div>

    <div class="page-content">

        <div #calendarWrapper></div>

        <p-table #dt 
            [value]="tunaPieceProcesses"                                                                                                      
            [rows]="10" 
            [paginator]="true" 
            [globalFilterFields]="['position','qrcode','name','description','tags','status','filledAt','emptiedAt','fishWeightAverage','fishNumber','fishMortality','harvestName','cageName','fridgeName','customerName', 'customerMarket', 'fishStatus','customerUnitPrice','tunaPieceName']"
            [rowsPerPageOptions]="[5,10,25,50,100]"
            [(selection)]="selectedTunaPieceProcesses" 
            [resizableColumns]="true"
            [reorderableColumns]="true"
            [rowHover]="true" 
            dataKey="$key"
            styleClass="p-datatable-striped"
            currentPageReportTemplate="{first} to {last} of {totalRecords}" 
            [showCurrentPageReport]="true"
            selectionMode="multiple"
            [columns]="selectedColumns"
            (onRowReorder)="reorder($event)"
            sortField="position" 
            [sortOrder]="1"
            >

            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="max-width:10%">
                    <col style="max-width:20%">
                    <col style="min-width:10%;max-width:80%">
                    <col style="max-width:20%">
                </colgroup>
            </ng-template>
            
            <ng-template pTemplate="caption">
                <p-multiSelect [options]="cols" [(ngModel)]="selectedColumns" optionLabel="header"
                selectedItemsLabel="{0} columns selected" [style]="{minWidth: '200px'}" placeholder="Choose Columns"></p-multiSelect>
            </ng-template>

            <ng-template pTemplate="header" let-columns="columns">
                <tr>
                    <th pResizableColumn pSortableColumn="position" style="width: 8rem">
                        Order<p-sortIcon field="position"></p-sortIcon>
                    </th>
                    <th id="qrcode" style="width: 8rem" name="qrcode" pResizableColumn pReorderableColumn pSortableColumn="qrcode" [class]="includesCol('qrcode') ? 'd' : 'h'">QRCode 
                        <p-sortIcon field="name"></p-sortIcon> 
                        <p-columnFilter type="text" field="name" display="menu"></p-columnFilter> 
                    </th>
                    <th id="name" name="name" pResizableColumn pReorderableColumn pSortableColumn="name" [class]="includesCol('name') ? 'd' : 'h'">Process Id 
                        <p-sortIcon field="name"></p-sortIcon> 
                        <p-columnFilter type="text" field="name" display="menu"></p-columnFilter>
                    </th>

                    <th id="harvestName" name="harvestName" pResizableColumn pReorderableColumn pSortableColumn="harvestName" [class]="includesCol('harvestName') ? 'd' : 'h'">
                        <img style="vertical-align: middle;" src="assets/images-black/ic_fishboat.png" width="24px" height="24px" [routerLink]="['/fish-management/harvests']"/> 
                        Harvest 
                        <p-sortIcon field="harvestName"></p-sortIcon> 
                        <p-columnFilter type="text" field="harvestName" display="menu"></p-columnFilter>
                    </th>

                    <th id="cageName" name="cageName" pResizableColumn pReorderableColumn pSortableColumn="cageName" [class]="includesCol('cageName') ? 'd' : 'h'">
                        <img style="vertical-align: middle;" src="assets/images-black/ic_cage.png" width="24px" height="24px" [routerLink]="['/fish-management/cages']"/> 
                        Cage
                        <p-sortIcon field="cageName"></p-sortIcon> 
                        <p-columnFilter type="text" field="cageName" display="menu"></p-columnFilter>
                    </th>

                    <th id="tunaPieceName" name="tunaPieceName" pResizableColumn pReorderableColumn pSortableColumn="tunaPieceName" [class]="includesCol('tunaPieceName') ? 'd' : 'h'">Tuna Piece Name 
                        <p-sortIcon field="tunaPieceName"></p-sortIcon> 
                        <p-columnFilter type="text" field="tunaPieceName" display="menu"></p-columnFilter>
                    </th>

                    <th id="fishWeight" name="fishWeight" pResizableColumn pReorderableColumn pSortableColumn="fishWeight" [class]="includesCol('fishWeight') ? 'd' : 'h'">
                        Total Weight (pieces)
                        <p-sortIcon field="fishWeight"></p-sortIcon> 
                        <p-columnFilter type="numeric" field="fishWeight" display="menu"></p-columnFilter>
                    </th>

                    <th id="fishAverageWeight" name="fishAverageWeight" pResizableColumn pReorderableColumn pSortableColumn="fishAverageWeight" [class]="includesCol('fishAverageWeight') ? 'd' : 'h'">
                        Avg Weight (pieces) 
                        <p-sortIcon field="fishAverageWeight"></p-sortIcon> 
                        <p-columnFilter type="numeric" field="fishAverageWeight" display="menu"></p-columnFilter>
                    </th>

                    <th id="fishNumber" name="fishNumber" pResizableColumn pReorderableColumn pSortableColumn="fishNumber" [class]="includesCol('fishNumber') ? 'd' : 'h'">
                        Pieces (nb) 
                        <p-sortIcon field="fishNumber"></p-sortIcon> 
                        <p-columnFilter type="numeric" field="fishNumber" display="menu"></p-columnFilter>
                    </th>

                    <!-- <th id="fishMortality" name="fishMortality" pResizableColumn pReorderableColumn pSortableColumn="fishMortality" [class]="includesCol('fishMortality') ? 'd' : 'h'">
                        Fish Mortality (nb / %)
                        <p-sortIcon field="fishMortality"></p-sortIcon> 
                        <p-columnFilter type="numeric" field="fishMortality" display="menu"></p-columnFilter>
                    </th> -->

                    <th id="fishLocation" name="fishLocation" pResizableColumn pReorderableColumn pSortableColumn="fishLocation" [class]="includesCol('fishLocation') ? 'd' : 'h'">
                        <img style="vertical-align: middle;" src="assets/images-black/ic_fridge.png" width="24px" height="24px" [routerLink]="['/fish-management/fridges']"/> 
                        Freezer
                        <p-sortIcon field="fishLocation"></p-sortIcon> 
                        <p-columnFilter type="text" field="fishLocation" display="menu"></p-columnFilter>
                    </th>

                    <th id="fishStatus" name="fishStatus" pResizableColumn pReorderableColumn pSortableColumn="nafishStatusme" [class]="includesCol('fishStatus') ? 'd' : 'h'">
                        <!-- <img style="vertical-align: middle;" src="assets/images-black/location.png" width="24px" height="24px" [routerLink]="['/fish-management/status']"/>  -->
                        Piece Status
                        <p-sortIcon field="fishStatus"></p-sortIcon> 
                        <p-columnFilter type="text" field="fishStatus" display="menu"></p-columnFilter>
                    </th>

                    <th id="customerMarket" name="customerMarket" pResizableColumn pReorderableColumn pSortableColumn="customerMarket" [class]="includesCol('customerMarket') ? 'd' : 'h'">
                        <!-- <img style="vertical-align: middle;" src="assets/images-black/location.png" width="24px" height="24px" [routerLink]="['/fish-management/markets']"/>  -->
                        Markets
                        <p-sortIcon field="customerMarket"></p-sortIcon> 
                        <p-columnFilter type="text" field="customerMarket" display="menu"></p-columnFilter>
                    </th>

                    <th id="customerName" name="customerName" pResizableColumn pReorderableColumn pSortableColumn="customerName" [class]="includesCol('customerName') ? 'd' : 'h'">
                        <img style="vertical-align: middle;" src="assets/images-black/location.png" width="24px" height="24px" [routerLink]="['/fish-management/clients']"/> 
                        Customers
                        <p-sortIcon field="customerName"></p-sortIcon> 
                        <p-columnFilter type="text" field="customerName" display="menu"></p-columnFilter>
                    </th>

                    <th id="customerUnitPrice" name="customerUnitPrice" pResizableColumn pReorderableColumn pSortableColumn="customerUnitPrice" [class]="includesCol('customerUnitPrice') ? 'show' : 'hide'">
                        Unit price
                        <p-sortIcon field="customerUnitPrice"></p-sortIcon> 
                        <p-columnFilter type="numeric" field="customerUnitPrice" display="menu"></p-columnFilter>
                    </th>

                    <th id="customerIsInvoiced" name="customerIsInvoiced" pResizableColumn pReorderableColumn pSortableColumn="customerIsInvoiced" style="width: 10rem" [class]="includesCol('customerIsInvoiced') ? 'show' : 'hide'">
                        Invoiced
                        <p-sortIcon field="customerIsInvoiced"></p-sortIcon> 
                        <p-columnFilter type="boolean" field="customerIsInvoiced" display="menu"></p-columnFilter>
                    </th>

                   
                    <th id="description" name="description" pResizableColumn pReorderableColumn [class]="includesCol('description') ? 'd' : 'h'">Description
                        <p-sortIcon field="description"></p-sortIcon> 
                        <p-columnFilter type="text" field="description" display="menu"></p-columnFilter>
                    </th>
                    <th id="tags" name="tags" pResizableColumn pReorderableColumn [class]="includesCol('tags') ? 'd' : 'h'">Tags
                        <p-sortIcon field="tags"></p-sortIcon> 
                        <p-columnFilter type="text" field="tags" display="menu"></p-columnFilter>
                    </th>

                    

                    <th id="filledAt" name="filledAt" pResizableColumn pReorderableColumn pSortableColumn="filledAt" [class]="includesCol('filledAt') ? 'd' : 'h'">
                        Filled at
                        <p-sortIcon field="filledAt"></p-sortIcon> 
                        <p-columnFilter type="datetime" field="filledAt" display="menu"></p-columnFilter>
                    </th>

                    <th id="emptiedAt" name="emptiedAt" pResizableColumn pReorderableColumn pSortableColumn="emptiedAt" [class]="includesCol('emptiedAt') ? 'd' : 'h'">
                        Emptied at
                        <p-sortIcon field="emptiedAt"></p-sortIcon> 
                        <p-columnFilter type="datetime" field="emptiedAt" display="menu"></p-columnFilter>
                    </th>

                    <th id="isEnabled" name="isEnabled" pResizableColumn pReorderableColumn pSortableColumn="isEnabled" style="width: 10rem" [class]="includesCol('isEnabled') ? 'show' : 'hide'">
                        Enabled
                        <p-sortIcon field="isEnabled"></p-sortIcon> 
                        <p-columnFilter type="boolean" field="isEnabled" display="menu"></p-columnFilter>
                    </th>
                    <th pResizableColumn pReorderableColumn style="width: 8rem">
                        Actions 
                        <!-- <button type="button" pButton pRipple icon="pi pi-file-o" (click)="dt.exportCSV();" class="p-mr-2" pTooltip="CSV" tooltipPosition="bottom"></button> -->
                        <p-tableHeaderCheckbox style="float: right;margin-right:3px" class="checkbox"></p-tableHeaderCheckbox>
                    </th>
                    
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-tunaPieceProcess let-columns="columns" let-index="rowIndex">
                <tr [pReorderableRow]="index" >
                    <td pEditableColumn>
                        <span *ngIf="isReordering && !isFilter" class="pi pi-bars" [pReorderableRowHandle]="index" style="margin-right: 1rem;"></span>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" 
                                (ngModelChange)="modelChangeFn($event, tunaPieceProcess)"
                                [ngModel]="tunaPieceProcess.position" 
                                (blur)="completePosition(tunaPieceProcess)" 
                                (keydown.tab)="completePosition(tunaPieceProcess)" 
                                (keydown.enter)="completePosition(tunaPieceProcess)"  
                                required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{index}}
                                <!-- ( {{tunaPieceProcess.position}} ) -->
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('qrcode') ? 'd' : 'h'">
                        <qrcode [qrdata]="tunaPieceProcess.name" [width]="100" [errorCorrectionLevel]="'M'"></qrcode>
                    </td>

                    <td pEditableColumn [class]="includesCol('name') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="tunaPieceProcess.name" 
                                (blur)="completeTunaPieceProcess(tunaPieceProcess)" 
                                (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" 
                                (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)" 
                                 required>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{tunaPieceProcess.name}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    

                    <!-- (blur)="completeTunaPieceProcess(tunaPieceProcess)" 
                    (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" 
                    (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)"  -->

                    <!-- (blur)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                    (keydown.tab)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                    (keydown.enter)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)"  -->


                    <td pEditableColumn [class]="includesCol('harvestName') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <!-- <input pInputText type="text" [(ngModel)]="tunaPieceProcess.harvestName"  (blur)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)"  required>
                                (blur)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                                 (keydown.tab)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                                 (keydown.enter)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                               (onChange)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)"
                                 
                                -->
                                 <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="true" 
                                    [ngModel]="tunaPieceProcess.harvestKey" 
                                    [options]="harvests" 
                                    optionLabel="name" 
                                    optionValue="$key"  
                                    (onChange)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)"
                                    (blur)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    placeholder="Any">
                                </p-dropdown>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <!-- <span >{{ tunaPieceProcess.harvestKey }}</span>
                                <span >{{ tunaPieceProcess.harvestName }}</span> -->
                                <span >{{displayHarvestName(tunaPieceProcess.harvestKey)}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('cageName') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <!-- <input 
                                pInputText type="text" 
                                [(ngModel)]="tunaPieceProcess.cageName" 
                                (blur)="completeTunaPieceProcess(tunaPieceProcess)" 
                                (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" 
                                (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)" 
                                 required> -->


                                 <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="true" 
                                    [ngModel]="tunaPieceProcess.cageKey" 
                                    [options]="cages" 
                                    optionLabel="name" 
                                    optionValue="$key"  
                                    (onChange)="onChangeCage(tunaPieceProcess, tunaPieceProcess.cageKey, $event)"
                                    (blur)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    placeholder="Any">
                                </p-dropdown>

                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{tunaPieceProcess.cageName}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('tunaPieceName') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                 <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="true" 
                                    [ngModel]="tunaPieceProcess.tunaPieceKey" 
                                    [options]="tunaPieces" 
                                    optionLabel="name" 
                                    optionValue="$key"  
                                    (onChange)="onChangeTunaPiece(tunaPieceProcess, tunaPieceProcess.tunaPieceKey, $event)"
                                    (blur)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    placeholder="Any">
                                </p-dropdown>

                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{tunaPieceProcess.tunaPieceName}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('fishWeight') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="number" [(ngModel)]="tunaPieceProcess.fishWeight"  (blur)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{tunaPieceProcess.fishWeight}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('fishAverageWeight') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="number" [(ngModel)]="tunaPieceProcess.fishAverageWeight"  (blur)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{tunaPieceProcess.fishAverageWeight}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('fishNumber') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="number" [(ngModel)]="tunaPieceProcess.fishNumber"  (blur)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{tunaPieceProcess.fishNumber}}</span>

                                <!-- <br>
                                <br> 1000 disposal
                                <br> 2500 reserved toto
                                <br> 2500 reserved titi -->
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    
                    <!-- <td pEditableColumn [class]="includesCol('fishMortality') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="number" [(ngModel)]="tunaPieceProcess.fishMortality"  (blur)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{tunaPieceProcess.fishMortality}} </span>
                                <span *ngIf="tunaPieceProcess.fishNumber && tunaPieceProcess.fishMortality">({{ tunaPieceProcess.fishMortality / tunaPieceProcess.fishNumber }} %)</span>
                            </ng-template>
                        </p-cellEditor>
                    </td> -->


                    <td pEditableColumn [class]="includesCol('fishLocation') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <!-- <input pInputText type="text" [(ngModel)]="tunaPieceProcess.harvestName"  (blur)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)"  required>
                                (blur)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                                 (keydown.tab)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                                 (keydown.enter)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                               (onChange)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)"
                                 
                                -->
                                <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="true" 
                                    [ngModel]="tunaPieceProcess.fridgeKey" 
                                    [options]="fridges" 
                                    optionLabel="name" 
                                    optionValue="$key"  
                                    (onChange)="onChangeFridge(tunaPieceProcess, tunaPieceProcess.fridgeKey, $event)"
                                    (blur)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    placeholder="Any">
                                </p-dropdown>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <!-- <span >{{ tunaPieceProcess.harvestKey }}</span>
                                <span >{{ tunaPieceProcess.harvestName }}</span> -->
                                <span >{{ tunaPieceProcess.fridgeName }}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('fishStatus') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <!-- <input pInputText type="text" [(ngModel)]="tunaPieceProcess.harvestName"  (blur)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)"  required>
                                (blur)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                                 (keydown.tab)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                                 (keydown.enter)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                               (onChange)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)"
                                 
                                -->
                                <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="true" 
                                    [(ngModel)]="tunaPieceProcess.status" 
                                    [options]="status" 
                                    (blur)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    placeholder="Any">
                                </p-dropdown>

                            </ng-template>
                            <ng-template pTemplate="output">
                                <!-- <span >{{ tunaPieceProcess.harvestKey }}</span>
                                <span >{{ tunaPieceProcess.harvestName }}</span> -->
                                <span >{{ tunaPieceProcess.status }}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('customerMarket') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <!-- <input pInputText type="text" [(ngModel)]="tunaPieceProcess.harvestName"  (blur)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)"  required>
                                (blur)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                                 (keydown.tab)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                                 (keydown.enter)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                               (onChange)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)"
                                 
                                -->
                                <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="true" 
                                    [(ngModel)]="tunaPieceProcess.market" 
                                    [options]="markets" 
                                    (blur)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    placeholder="Any">
                                </p-dropdown>
                    
                            </ng-template>
                            <ng-template pTemplate="output">
                                <!-- <span >{{ tunaPieceProcess.harvestKey }}</span>
                                <span >{{ tunaPieceProcess.harvestName }}</span> -->
                                <span >{{tunaPieceProcess.market}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('customerName') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <!-- <input pInputText type="text" [(ngModel)]="tunaPieceProcess.harvestName"  (blur)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)"  required>
                                (blur)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                                 (keydown.tab)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                                 (keydown.enter)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)" 
                               (onChange)="onChangeHarvest(tunaPieceProcess, tunaPieceProcess.harvestKey, $event)"
                                 
                                -->
                                <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="true" 
                                    [ngModel]="tunaPieceProcess.customerKey" 
                                    [options]="clients" 
                                    optionLabel="companyName" 
                                    optionValue="$key"  
                                    (onChange)="onChangeCustomer(tunaPieceProcess, tunaPieceProcess.customerKey, $event)"
                                    (blur)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)" 
                                    placeholder="Any">
                                </p-dropdown>
                                
                            </ng-template>
                            <ng-template pTemplate="output">
                                <!-- <span >{{ tunaPieceProcess.harvestKey }}</span>
                                <span >{{ tunaPieceProcess.harvestName }}</span> -->
                                <span >{{ tunaPieceProcess.customerName }}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('customerUnitPrice') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="number" [(ngModel)]="tunaPieceProcess.customerUnitPrice" 
                                (blur)="completeTunaPieceProcess(tunaPieceProcess)" 
                                (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" 
                                (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)" 
                                 required>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{tunaPieceProcess.customerUnitPrice}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('customerIsInvoiced') ? 'd' : 'h'" class="enabled" style="text-align: center;">
                        <p-inputSwitch  [(ngModel)]="tunaPieceProcess.customerIsInvoiced" (onChange)="completeTunaPieceProcess(tunaPieceProcess)"></p-inputSwitch>
                    </td>

                    <!-- { field: 'fishLocation', header: 'Fish Location' },
                    { field: 'fishStatus', header: 'Fish status' },
              
                    { field: 'customerMarket', header: 'Market' },
                    { field: 'customerName', header: 'Customer' },
                    { field: 'customerIsInvoiced', header: 'IsInvoiced' },
 -->

                    <td pEditableColumn [class]="includesCol('description') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="text" [(ngModel)]="tunaPieceProcess.description"  (blur)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.tab)="completeTunaPieceProcess(tunaPieceProcess)" (keydown.enter)="completeTunaPieceProcess(tunaPieceProcess)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{tunaPieceProcess.description}}</span>
                            
                         
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('tags') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <p-chips  id="tags" [(ngModel)]="tunaPieceProcess.tags" [separator]="separatorExp" placeholder="tag1, tag2 tag3" (onBlur)="completeTunaPieceProcess(tunaPieceProcess)" (onAdd)="completeTunaPieceProcess(tunaPieceProcess)" (onRemove)="completeTunaPieceProcess(tunaPieceProcess)"></p-chips>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span style="margin-right: 5px;" *ngFor="let tag of tunaPieceProcess.tags">
                                    <p-tag >{{tag}}</p-tag>
                                </span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('filledAt') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                
                                    <p-calendar 
                                        [(ngModel)]="tunaPieceProcess.filledAt"  
                                        [ngModelOptions]="{standalone: true}" 
                                        [showIcon]="true" 
                                        [showTime]="true" 
                                        [showSeconds]="true" 
                                        inputId="time" 
                                        [appendTo]="calendarWrapper"
                                        (onSelect)="onSelect($event,tunaPieceProcess)" 
                                        (onBlur)="onBlur($event,tunaPieceProcess)" 
                                        (onClose)="onClose($event,tunaPieceProcess)"
                                      >
                                    </p-calendar>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{tunaPieceProcess.filledAt | date: 'dd/MM/yyyy HH:mm' }}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('emptiedAt') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                
                                    <p-calendar 
                                        [(ngModel)]="tunaPieceProcess.emptiedAt"  
                                        [ngModelOptions]="{standalone: true}" 
                                        [showIcon]="true" 
                                        [showTime]="true" 
                                        [showSeconds]="true" 
                                        inputId="time" 
                                        [appendTo]="calendarWrapper"
                                        (onSelect)="onSelect($event,tunaPieceProcess)" 
                                        (onBlur)="onBlur($event,tunaPieceProcess)" 
                                        (onClose)="onClose($event,tunaPieceProcess)"
                                      >
                                    </p-calendar>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{tunaPieceProcess.emptiedAt | date: 'dd/MM/yyyy HH:mm' }}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>


                    <td pEditableColumn [class]="includesCol('isEnabled') ? 'd' : 'h'" class="enabled" style="text-align: center;">
                        <p-inputSwitch  [(ngModel)]="tunaPieceProcess.isEnabled" (onChange)="completeTunaPieceProcess(tunaPieceProcess)"></p-inputSwitch>
                    </td>

                    <td class="row-actions">
                        <!-- <button style="margin-right: 10px" pButton pRipple icon="pi pi-plus" class="p-button-rounded p-button-success p-mr-2" (click)="moveToFridge(tunaPieceProcess)"></button> -->
                        <button style="margin-right: 10px" pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="editTunaPieceProcess(tunaPieceProcess)"></button>
                        <button style="margin-right: 10px" pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteTunaPieceProcess(tunaPieceProcess)"></button>
                        <p-tableCheckbox class="checkbox" [value]="tunaPieceProcess"></p-tableCheckbox>
                        
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="summary">
                    <div class="summary-total">
                        Total: {{tunaPieceProcesses ? tunaPieceProcesses.length : 0 }} tuna process{{tunaPieceProcesses.length > 1? 'es': ''}}
                    </div>
                    <div class="summary-export">
                        <button style="margin-right: 10px"type="button" pButton pRipple icon="pi pi-file-o" (click)="exportToCsv()" class="p-mr-2" pTooltip="CSV - Save the selected lines and columns" tooltipPosition="bottom"></button>
                        <button style="margin-right: 10px"type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS - Save all the lines and columns" tooltipPosition="bottom"></button>
                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF - Save all the lines and columns" tooltipPosition="bottom"></button>
                    </div>
                </div>
            </ng-template>
        </p-table>

    </div>

    <div class="page-footer">
        <div class="p-d-flex" >
            Reports: <br/>
            - Invoiced: {{ getInvoicedAmount() }} AUD
            - Not invoiced: {{ getNotInvoicedAmount() }} AUD
            <!-- <ul>
                <li >test</li>
            </ul> -->
            <!-- <button type="button" pButton pRipple icon="pi pi-filter" (click)="dt.exportCSV({selectionOnly:true})" class="p-button-info p-ml-auto" pTooltip="Selection Only" tooltipPosition="bottom"></button> -->
        </div>        
    </div>

    <!-- Dialog : confirm -->
    <p-confirmDialog [style]="{width: '450px'}">

        <ng-template pTemplate="header">
            <h3>Header Content</h3>
        </ng-template>
        <ng-template pTemplate="">
mess
        </ng-template>
        <!-- <ng-template pTemplate="footer">
            <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
            <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
        </ng-template> -->
        
    </p-confirmDialog>

     <!-- Dialog : Popup move -->
     <p-dialog [(visible)]="moveDialog" [style]="{width: '450px', height: '375px'}" header="Move to freezer" [modal]="true" styleClass="p-fluid" [baseZIndex]='1000'>
        

        

        <div class="p-field" style="margin-top: 10px;">
            <label><b>From</b></label>
            <span> {{ tunaPieceProcess.name }} </span>
        </div>

        

        <div class="p-field" style="margin-top: 20px;">
            <label><b>To</b></label>
            
            <label for="location">&nbsp;&nbsp; Freezer &nbsp;&nbsp; </label>
            <img style="vertical-align: middle;" src="assets/images-black/ic_fridge.png" width="24px" height="24px" [routerLink]="['/fish-management/fridges']"/> 
            <div style="margin-top: 10px;"></div>
            <p-dropdown 
                appendTo="body" 
                [filter]="true"
                [showClear]="true" 
                [(ngModel)]="fridgeKey" 
                [options]="fridges" 
                optionLabel="name" 
                optionValue="$key"
                placeholder="Any">
            </p-dropdown>
        </div>

        <div class="p-field" style="margin-top: 10px;">
            <label for="quantity">Quantity</label>
            <input style="margin-top: 10px;" type="number" pInputText id="quantity" [(ngModel)]="quantity" required autofocus value="{{ tunaPieceProcess.fishNumber }}"/>
            <small class="p-error" *ngIf="submitted && !tunaPieceProcess.name">Quantity is required.</small>
        </div>


        <!-- <div class="p-field">
            <label for="description">Description</label>
            <textarea style="margin-top: 10px;" id="description" pInputTextarea [(ngModel)]="tunaPieceProcess.description" rows="3" cols="20"></textarea>
        </div>
        <div class="p-field">
            <label for="tags" >Tags</label>
            <div style="height: 10px;">&nbsp;</div>
            <p-chips  id="tags" [(ngModel)]="tunaPieceProcess.tags" [separator]="separatorExp" placeholder="tag1, tag2 tag3"></p-chips>
        </div>    -->
        <div class="in-out" style="margin-top: 20px;">
            <button pButton pRipple label="Cancel" icon="pi pi-times" class="button-action p-button-danger p-mr-2" (click)="hideMoveDialog()"></button>
            <button pButton pRipple label="Save" icon="pi pi-check" class="button-action p-button-success" (click)="saveTunaPieceProcess()"></button>
        </div>
    </p-dialog>
    

    <!-- Dialog : Popup -->
    <p-dialog [(visible)]="tunaPieceProcessDialog" [style]="{width: '450px', height: '450px'}" header="TunaPieceProcess" [modal]="true" styleClass="p-fluid" [baseZIndex]='1000'>
        <div class="p-field" style="margin-top: 10px;">
            <label for="title">Name</label>
            <input style="margin-top: 10px;" type="text" pInputText id="name" [(ngModel)]="tunaPieceProcess.name" required autofocus />
            <small class="p-error" *ngIf="submitted && !tunaPieceProcess.name">Name is required.</small>
        </div>
        <div class="p-field">
            <label for="description">Description</label>
            <textarea style="margin-top: 10px;" id="description" pInputTextarea [(ngModel)]="tunaPieceProcess.description" rows="3" cols="20"></textarea>
        </div>
        <div class="p-field">
            <label for="tags" >Tags</label>
            <div style="height: 10px;">&nbsp;</div>
            <p-chips  id="tags" [(ngModel)]="tunaPieceProcess.tags" [separator]="separatorExp" placeholder="tag1, tag2 tag3"></p-chips>
        </div>   
        <div class="in-out" style="margin-top: 20px;">
            <button pButton pRipple label="Cancel" icon="pi pi-times" class="button-action p-button-danger p-mr-2" (click)="hideDialog()"></button>
            <button pButton pRipple label="Save" icon="pi pi-check" class="button-action p-button-success" (click)="saveTunaPieceProcess()"></button>
        </div>
    </p-dialog>

    <!-- { field: 'harvestKey', header: 'Harvest' },
                    { field: 'fishAverageWeight', header: 'Weight (avg)' },
                    { field: 'fishNumber', header: 'Fish (nb)' },
                    { field: 'fishMortality', header: 'Mortality (nb / %)' },
                    { field: 'filledAt', header: 'Filled at' },
                    { field: 'emptiedAt', header: 'Emptied at' },
     -->
    

</div>


